export default "__VITE_PUBLIC_ASSET__e33f86dd__"